import { render, staticRenderFns } from "./monitorList.vue?vue&type=template&id=5d3f130c&scoped=true&"
import script from "./monitorList.vue?vue&type=script&lang=js&"
export * from "./monitorList.vue?vue&type=script&lang=js&"
import style0 from "./monitorList.vue?vue&type=style&index=0&id=5d3f130c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d3f130c",
  null
  
)

export default component.exports